import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})

export class AuthInterceptor implements HttpInterceptor {

    constructor(private auth: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if((req.url.toLowerCase().indexOf("admin") >=0) && this.auth && this.auth.accessToken){
            const authReq = req.clone({
                setHeaders: { Authorization: `Bearer ${this.auth.accessToken}` }
            });
            return next.handle(authReq);
        }
        else {
            return next.handle(req);
        }
    }
}
  